// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  onAuthStateChanged, 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signInWithPopup, 
  updateProfile, 
  signOut,
  sendPasswordResetEmail,
  sendEmailVerification
} from "firebase/auth";
import { 
  getFirestore, 
  collection, 
  doc, 
  setDoc, 
  getDoc, 
  getDocs, 
  query, 
  where, 
  updateDoc, 
  deleteDoc, 
  addDoc, 
  serverTimestamp,
  arrayUnion,
  arrayRemove,
  increment,
  orderBy,
  limit,
  startAfter,
  onSnapshot,
  writeBatch
} from "firebase/firestore";
import { 
  getStorage, 
  ref, 
  uploadBytes, 
  getDownloadURL, 
  deleteObject,
  uploadBytesResumable,
  listAll
} from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyACxOt6dyUIS8XrzdlrnNHbM407FMly8b0", // ✅ NEW RESTRICTED KEY
  authDomain: "skytone-app.firebaseapp.com",
  projectId: "skytone-app",
  storageBucket: "skytone-app.firebasestorage.app",
  messagingSenderId: "205665010837",
  appId: "1:205665010837:web:45c7453acbee4cb79a079c", // ✅ NEW APP ID
  measurementId: "G-MH6X076NFF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();

// ============================================================
// INITIALIZE APP CHECK (To block the bots)
// ============================================================
// Enable debug token for localhost so App Check doesn't break local dev
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider('6LcqU_ctAAAAAI1tWt-lGAz_u2L0d8KJqlX308n_'), // ✅ YOUR RECAPTCHA KEY
  isTokenAutoRefreshEnabled: true
});

// Export everything
export { 
  // Firebase app
  app,
  analytics,
  
  // Auth
  auth,
  googleProvider,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  updateProfile,
  signOut,
  sendPasswordResetEmail,
  sendEmailVerification,
  
  // Firestore
  db,
  collection,
  doc,
  setDoc,
  getDoc,
  getDocs,
  query,
  where,
  updateDoc,
  deleteDoc,
  addDoc,
  serverTimestamp,
  arrayUnion,
  arrayRemove,
  increment,
  orderBy,
  limit,
  startAfter,
  onSnapshot,
  writeBatch,
  
  // Storage
  storage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  uploadBytesResumable,
  listAll
};